import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { AppRoutes } from './routes/AppRoutes';
import DirectAuthHandler from './components/DirectAuthHandler';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <DirectAuthHandler />
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
